export default __webpack_public_path__ + "static/media/rank-icon.b65270a1.svg";